<template>
  <div
    v-if="showSheet"
    id="sac-bottom-sheet-overlay"
    :class="[
      sheetClass,
    ]"
  >
    <div
      v-if="close"
      class="close-background"
      @click="hideSheet"
    />
    <div
      :class="[
        'sheet-card',
        show ? 'slide-up' : 'slide-down',
        cardClass,
      ]"
    >
      <slot name="content" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'SACBottomSheet',
  props: {
    show: Boolean,
    close: Function,
    sheetClass: String,
    cardClass: String,
  },
  data() {
    return {
      showSheet: this.show,
    };
  },
  watch: {
    show(show) {
      if (!show) {
        setTimeout(() => {
          this.showSheet = show;
          this.enableScroll();
        }, 200);
      } else {
        this.showSheet = show;
        this.disableScroll();
      }
    },
  },
  beforeDestroy() {
    this.enableScroll();
  },
  methods: {
    hideSheet() {
      if (this.close) {
        this.close();
      }
    },
    disableScroll() {
      document.documentElement.style.overflowY = 'hidden';
    },
    enableScroll() {
      document.documentElement.style.overflowY = 'auto';
    },
  },
};
</script>

<style lang="scss">

#sac-bottom-sheet-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  color: $BLACK;
  .close-background {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1;
  }
  .sheet-card {
    background-color: transparent;
    transition: all 0.25s ease;
    border-radius: 12px;
    position: absolute;
    z-index: 2;
    height: 90vh;
    bottom: 0;
    &.slide-up {
      animation-fill-mode: forwards;
      animation: slideUp 0.25s ease;
    }
    &.slide-down {
      animation-fill-mode: forwards;
      animation: slideDown 0.25s ease;
    }
  }
}

@keyframes slideUp {
  0% {
    top: 100%;
  }
  100% {
    top: 100px;
  }
}

@keyframes slideDown {
  0% {
    top: 100px;
  }
  100% {
    top: 100%;
  }
}
</style>
